// Dice's own page entry (index.html, generated by vendor-sync: the vendored game's classic scripts have run when this
// module executes). The launch is taken first, synchronously; boot.ts holds the composition root. The gw shell boots
// through shell-entry.ts instead (SC-54713).
import { bootDice, showBootFailure, takeLaunchEarly } from "./boot";

const early = takeLaunchEarly();
bootDice(early).catch((e: unknown) => {
  console.error("[dice] boot failed:", e);
  showBootFailure(early);
});
